import React, { FC, useEffect, useState } from 'react';
import { HiOutlineX, HiOutlineCheck } from 'react-icons/hi';
import { CustomEditor, Input } from '../../../../../commons';
import { Button } from '../../../../../ui/Button';

interface NewItinaryFormProps {
  handleAddItinary: () => void;
  isEdit?: boolean;
  handleCancelEdit?: () => void;
  values: any;
  setFieldValue: any;
}

const NewItinaryForm: FC<NewItinaryFormProps> = ({
  handleAddItinary,
  isEdit,
  handleCancelEdit,
  values,
  setFieldValue,
}) => {
  const [initialValue, setInitialValue] = useState(values.itinaryDescription);

  useEffect(() => {
    setFieldValue('itinaryDescription', initialValue);
  }, [initialValue]);

  useEffect(() => {
    setInitialValue(values.itinaryDescription);
  }, [values.itinaryDescription]);

  return (
    <div id='edit' className='p-6 bg-white dark:bg-gray-800 rounded-xl border border-gray-100 dark:border-gray-700/50 shadow-sm'>
      <div className='grid grid-cols-1 md:grid-cols-12 gap-6 items-start mb-6'>
        <div className='md:col-span-2'>
          <Input type='text' name='day' label='Day' />
        </div>
        <div className='md:col-span-10'>
          <Input type='text' name='itinaryTitle' label='Itinerary Title' />
        </div>
      </div>

      <div className='mb-6'>
        <CustomEditor
          placeholder='Type tour itinerary description here...'
          onChange={setInitialValue}
          value={initialValue}
          customClass='itinary-editor'
          name='itinaryDescription'
        />
      </div>

      <div className='grid grid-cols-1 md:grid-cols-2 gap-6 items-end'>
        <div className='col-span-1'>
          <Input type='text' name='meal_plan' label='Meal Plan' />
        </div>
        <div className='col-span-1'>
          <Input type='text' name='accommodation_plan' label='Accommodation Plan' />
        </div>
      </div>

      <div className='flex justify-end gap-3 mt-6 pt-6 border-t border-gray-100 dark:border-gray-700/50'>
        {isEdit ? (
          <>
            <Button
              variant='outline-secondary'
              onClick={handleCancelEdit}
              title='Cancel Edit'
              leftIcon={<HiOutlineX className='w-4 h-4' />}
            >
              Cancel
            </Button>
            <Button
              variant='primary'
              onClick={handleAddItinary}
              title='Save Changes'
              leftIcon={<HiOutlineCheck className='w-4 h-4' />}
            >
              Save Changes
            </Button>
          </>
        ) : (
          <Button
            variant='primary'
            onClick={handleAddItinary}
            fullWidth
            className='md:w-auto md:min-w-[120px]'
            leftIcon={<HiOutlineCheck className='w-4 h-4' />}
          >
            {values.itineraries.length === values.days - 1 ? 'Finish' : 'Add Itinerary'}
          </Button>
        )}
      </div>
    </div>
  );
};

export default NewItinaryForm;
